import { gql } from "apollo-angular";
import { PaginationFragment } from "../fragments/pagination";

export const DNS_FIREWALL_QUERY = gql`
  ${PaginationFragment}
  query GetDnsFirewall(
    $filter: DnsFirewallSearchFilter = {}
    $first: Int = 20
    $after: Int = 0
    $sort: DnsFirewallSort
  ) {
    dnsFirewallLogs(searchFilter: $filter, first: $first, after: $after, sort: $sort) {
      edges {
        node {
          customerId
          ipAddress
          rpzFeed
          hit
          recordedAt
          resolver
          action
        }
        cursor
      }
      pageInfo {
        ...PaginationInfo
      }
    }
  }
`;
